import React from 'react';
import SectionWrapper from '../ui/SectionWrapper';
import SafeIcon from '../../common/SafeIcon';
import { FiShield, FiUserCheck, FiDatabase, FiTrendingUp } from 'react-icons/fi';

const ExpertiseCard = ({ icon, title, description, skills }) => (
  <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 hover:shadow-md hover:border-teal-100 transition-all group">
    <div className="w-12 h-12 bg-slate-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-teal-50 transition-colors">
      <SafeIcon icon={icon} className="text-2xl text-slate-700 group-hover:text-teal-600 transition-colors" />
    </div>
    <h3 className="text-xl font-bold text-slate-900 mb-3">{title}</h3>
    <p className="text-slate-600 mb-6 leading-relaxed text-sm">
      {description}
    </p>
    <div className="flex flex-wrap gap-2">
      {skills.map((skill) => (
        <span key={skill} className="px-2.5 py-1 bg-slate-100 text-slate-600 text-xs font-medium rounded-md">
          {skill}
        </span>
      ))}
    </div>
  </div>
);

const Expertise = () => {
  const areas = [
    {
      icon: FiShield,
      title: "Security & Trust Systems",
      description: "Designing architectures that prioritize user safety and data integrity without compromising experience. I build systems that resist fraud and build long-term reputation.",
      skills: ["Cybersecurity Strategy", "Fraud Mitigation", "Risk Assessment", "Trust & Safety"]
    },
    {
      icon: FiUserCheck,
      title: "Authentication & Identity",
      description: "Implementing next-gen identity verification to stop impersonation. Specializing in biometric integration and multi-factor authentication flows.",
      skills: ["Biometrics", "MFA/3FA", "Anti-Deepfake", "Identity Verification (IDV)"]
    },
    {
      icon: FiDatabase,
      title: "Data Platforms & Automation",
      description: "Streamlining operations through intelligent data pipelines and automation. Turning raw data into actionable insights for cleaner, faster decision making.",
      skills: ["Data Architecture", "Workflow Automation", "Platform Engineering", "Analytics"]
    },
    {
      icon: FiTrendingUp,
      title: "Startup Execution",
      description: "Bridging the gap between technical possibility and market reality. I help founders launch products that are secure, compliant, and positioned for growth.",
      skills: ["Go-to-Market", "Product Strategy", "Technical Advisory", "Agile Leadership"]
    }
  ];

  return (
    <SectionWrapper id="expertise" background="#f8fafc">
      <div className="text-center max-w-3xl mx-auto mb-16">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Core Expertise</h2>
        <p className="text-lg text-slate-600">
          My work focuses on high-impact areas where security meets usability.
        </p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-8">
        {areas.map((area, index) => (
          <ExpertiseCard key={index} {...area} />
        ))}
      </div>
    </SectionWrapper>
  );
};

export default Expertise;